module.exports = __webpack_public_path__ + "img/landing-subscription-screen-2.962f84ef.png";